import { render, staticRenderFns } from "./TemplateKurzveranstaltung.vue?vue&type=template&id=44601c87&"
import script from "./TemplateKurzveranstaltung.vue?vue&type=script&lang=js&"
export * from "./TemplateKurzveranstaltung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports